import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/nettleworth-frontend/src/components/LocaleLink.js");
